// Runtime webpack config
import '../../other/WebpackConfig';

import '../../../scss/homepage.twh.frbe.scss';

// i18n
import i18n from '../../i18n/fr-BE';

import homepage from './homepage';

homepage(i18n);
